export default __webpack_public_path__ + "static/media/logo-yellow.f4cb20d9.svg";